import React from "react";
// import ProductView from "./ProductView";
import { useFilterContext } from "../context/FilterContext";
import ProductView from "./ProductView";
// import ListView from "./ListView";

const ProductList = () => {
    const { filter_products } = useFilterContext();

    // const { isLoading, products } = useProductContext();

    // if (isLoading) {
    //     return <div> ......Loading </div>;
    // }
    // console.log('prod list',filter_products);

    // if (grid_view === true) {
    //     return <ProductView products={filter_products} />;
    //   }

    //   if (grid_view === false) {
    //     return <ListView products={filter_products} />;
    //   }

    return <>
        <div className="product-data mb-2">
            <h3>{`${filter_products.length} Product Available`}</h3>
        </div>

        <ProductView products={filter_products} /></>;

};

export default ProductList; 